import { createContext, useContext } from 'react';

// ----------------------------------------------------------------------

export const SiteContext = createContext({
  site: null,
  siteConfig: null,
  tempSiteConfig: null,
  tempConfigHistory: [], // 一時保存の履歴配列を追加
  historyIndex: -1,      // 履歴内の現在の位置を追加
  hasTempChanges: false,
  sites: [],
  loading: true,
  setSite: () => {},
  setSiteConfig: () => {},
  saveTempConfig: () => {},
  applyTempConfig: () => {},
  getTempConfig: () => {},
  clearTempConfig: () => {}, // 一時保存をクリアする関数を追加
  getPreviousTempConfig: () => {}, // 前の一時保存に戻る関数を追加
  getNextTempConfig: () => {},     // 次の一時保存に進む関数を追加
  hasPreviousTempConfig: () => {}, // 前の一時保存があるかを確認する関数を追加
  hasNextTempConfig: () => {},     // 次の一時保存があるかを確認する関数を追加
});

export const useSiteContext = () => {
  const context = useContext(SiteContext);

  if (!context) throw new Error('useSiteContext must be use inside SiteProvider');

  return context;
};
